import { API_BASE_URL } from "../config/config";
import axios from "axios";
import Cookies from "js-cookie";

const ThreeDSToken = async (uid) => {
    //ask txshield to get the token for the user from threeds
    let options = { headers: { Authorization: "Bearer " + Cookies.get("access_token") } };

    const threedstoken = await axios
        .get(API_BASE_URL + "/v3/user/" + uid + "/getThreeDSToken", options)
        .then(({ data }) => {

            if (data.token) return data.token;
            // else console.log(data); - comment out since for every user login we're checking the threeds association
        })
        .catch((error) => {
            // console.log(error); - comment out since for every user login we're checking the threeds association
            return false;
        });
    if (threedstoken) {
        Cookies.set("threeds_token", threedstoken, { secure: true, sameSite: "Strict" });
    }
    return threedstoken;

};
export default ThreeDSToken;